import { MuiHelpers_createElement } from "../../src/Feliz.MaterialUI/./Mui.fs.js";
import { Paper } from "@mui/material";
import { ofArray } from "./fable_modules/fable-library.3.7.18/List.js";
import { Interop_reactApi } from "./fable_modules/Feliz.1.68.0/Interop.fs.js";
import react_highlight from "react-highlight";
import { createObj } from "./fable_modules/fable-library.3.7.18/Util.js";
import { Interop_reactApi as Interop_reactApi_1 } from "./fable_modules/Feliz.1.68.0/./Interop.fs.js";

export function Code(codeInputProps) {
    let elements, props;
    const code = codeInputProps.code;
    const language = codeInputProps.language;
    return MuiHelpers_createElement(Paper, [["elevation", 0], (elements = [(props = ofArray([["className", (language === "f#") ? "fsharp" : language], ["children", code]]), Interop_reactApi.createElement(react_highlight, createObj(props)))], ["children", Interop_reactApi_1.Children.toArray(Array.from(elements))])]);
}

